import React from 'react'
import { cn } from '../../../lib/utils'
import { formFieldBaseClass, formFieldFocusClass } from './formFieldStyles'

export interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  label?: string
  helperText?: string
  errorText?: string
}

const Input = React.forwardRef<HTMLInputElement, InputProps>(
  ({ className, label, helperText, errorText, id, ...props }, ref) => {
    const generatedId = React.useId()
    const inputId = id ?? generatedId

    return (
      <div className="w-full">
        {label ? (
          <label
            htmlFor={inputId}
            className="mb-[6px] block font-sans text-fs-300 font-medium text-ink-600"
          >
            {label}
          </label>
        ) : null}

        <input
          ref={ref}
          id={inputId}
          className={cn(
            'pb-input w-full rounded-input px-4 py-[14px] font-sans',
            formFieldBaseClass,
            formFieldFocusClass,
            'disabled:pointer-events-none disabled:opacity-35',
            className
          )}
          {...props}
        />

        {errorText ? (
          <p className="mt-[6px] font-sans text-fs-300 text-error-400">
            {errorText}
          </p>
        ) : helperText ? (
          <p className="mt-[6px] font-sans text-fs-300 text-ink-500">
            {helperText}
          </p>
        ) : null}
      </div>
    )
  }
)

Input.displayName = 'Input'

export { Input }
